import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import {
  formatColumnDate,
  dateFilterParams,
  headerInfoTooltipDef,
  getValueBgClass,
  formatPercentage,
} from '../lib/utils';

const defaultFilterParams = {
  newRowsAction: 'keep',
};

export default [
  {
    cellClass: 'ticker-cell',
    field: 'date',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      inRangeInclusive: true,
    },
    headerName: 'Date',
    initialSort: 'desc' as ColDef['initialSort'],
    initialWidth: 80,
    valueFormatter: ({ data }) => formatColumnDate(data.date),
    valueGetter: ({ data }) => {
      if (!data.date) return null;

      return data.date;
    },
    ...headerInfoTooltipDef('Date Retail Sales data is reported to the public'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    field: 'ticker',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    initialWidth: 60,
    ...headerInfoTooltipDef('Symbol associated with the company who is reporting Retail Sales'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      return (
        <div className="company-name-cell">
          <span>{data.name}</span>
          {data.logo && <img alt="" className="bz-ag-table__company-image" loading="lazy" src={data.logo}></img>}
        </div>
      );
    },
    field: 'name',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Company Name',
    initialWidth: 160,
    ...headerInfoTooltipDef('Symbol associated with the company who is reporting Retail Sales'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'period',
    filter: 'quarterFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Period',
    initialWidth: 50,
    ...headerInfoTooltipDef('Time Frame being reported'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'period_year',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Period Year',
    initialWidth: 80,
    ...headerInfoTooltipDef('Year of guidance issuance'),
  },
  {
    cellClass: ({ value }) => getValueBgClass(value),
    cellStyle: { fontWeight: 'bold', textAlign: 'left' },
    comparator: (valueA, valueB) => {
      return valueA - valueB;
    },
    field: 'sss',
    filter: 'priceFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
      values: [
        {
          label: '0% - 10%',
          rules: (value: number) => {
            return value >= 0 && value <= 10;
          },
        },
        {
          label: '10% - 20%',
          rules: (value: number) => {
            return value >= 10 && value <= 20;
          },
        },
        {
          label: '20% - 30%',
          rules: (value: number) => {
            return value >= 20 && value <= 30;
          },
        },
        {
          label: '30% - 40%',
          rules: (value: number) => {
            return value >= 30 && value <= 40;
          },
        },
        {
          label: ' > 40%',
          rules: (value: number) => {
            return value >= 40;
          },
        },
        {
          label: '0% - -10%',
          rules: (value: number) => {
            return value >= -10 && value < 0;
          },
        },
        {
          label: '-10% - -20%',
          rules: (value: number) => {
            return value >= -20 && value <= -10;
          },
        },
        {
          label: '-20% - -30%',
          rules: (value: number) => {
            return value >= -30 && value <= -20;
          },
        },
        {
          label: '-30% - -40%',
          rules: (value: number) => {
            return value >= -40 && value <= -30;
          },
        },
        {
          label: ' < -40%',
          rules: (value: number) => {
            return value <= -40;
          },
        },
      ],
    },
    headerName: 'Same Store Sales',
    initialWidth: 100,
    valueFormatter: ({ value }) => formatPercentage(value),
    ...headerInfoTooltipDef('Year over Year look at sales from the same stores'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: () => {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href="https://www.benzinga.com/profile/portfolio/?action=login&utm_source=calendars" target="_blank">
          Get Alert
        </a>
      );
    },
    field: 'get_alert',
    headerName: 'Get Alert',
    initialWidth: 70,
    suppressAutoSize: true,
    suppressMenu: true,
    suppressSizeToFit: true,
  },
] as (ColDef | ColGroupDef)[];
